declare const THREE: any;

const getControls = (camera: any, renderer: any): any => {
  const controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
  controls.dampingFactor = 0.5;

  controls.screenSpacePanning = true;

  controls.minDistance = 200;
  controls.maxDistance = 40000;

  controls.autoRotateSpeed = 1.0;
  controls.target = new THREE.Vector3(0, 0, 0);

  controls.enablePan = true;
  controls.enableZoom = false;

  return controls;
};

export default getControls;
